export default function Footer() {
  return (
    <footer className="bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-base font-bold text-white">
                99
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">99爆料</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              圈内人都在看的爆料入口。汇集内部人士、知情人士与工作人员的小道消息与行业观察，认真记录、诚实标注，带你看见台前幕后不为人知的一面。
            </p>
            <div className="mt-5 flex items-center gap-2 text-xs text-foreground-500">
              <i className="ri-mail-line" />
              hello@99baoliao.example
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900">栏目</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li><a href="#hot" className="transition-colors hover:text-primary-600">今日热闻</a></li>
              <li><a href="#paoliao" className="transition-colors hover:text-primary-600">圈子爆料</a></li>
              <li><a href="#deep" className="transition-colors hover:text-primary-600">深度观察</a></li>
              <li><a href="#people" className="transition-colors hover:text-primary-600">幕后人物</a></li>
              <li><a href="#rank" className="transition-colors hover:text-primary-600">热度榜单</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900">支持与联系</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li><a href="#faq" className="transition-colors hover:text-primary-600">常见问题</a></li>
              <li><a href="#about" className="transition-colors hover:text-primary-600">关于我们</a></li>
              <li><a href="#contact" className="transition-colors hover:text-primary-600">我要投稿</a></li>
              <li><a href="#contact" className="transition-colors hover:text-primary-600">内容纠错</a></li>
              <li><a href="#about" className="transition-colors hover:text-primary-600">免责声明</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">© 2026 99爆料 · 圈内资讯门户</p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#top" className="flex items-center gap-1 transition-colors hover:text-primary-600">
              <i className="ri-arrow-up-line" />
              回到顶部
            </a>
            <span>内容以原文为准 · 请理性看待</span>
          </div>
        </div>
      </div>
    </footer>
  );
}